import dayjs from "dayjs";

export function convertToDayWithNumber(dayIndex: number, t: any) {
  switch (dayIndex) {
    case 1:
      // return `월요일`;
      return `${t("common.monday")}`;
    case 2:
      // return `화요일`;
      return `${t("common.tuesday")}`;
    case 3:
      // return `수요일`;
      return `${t("common.wednesday")}`;
    case 4:
      // return `목요일`;
      return `${t("common.thursday")}`;
    case 5:
      // return `금요일`;
      return `${t("common.friday")}`;
    case 6:
      // return `토요일`;
      return `${t("common.saturday")}`;
    case 7:
      // return `일요일`;
      return `${t("common.sunday")}`;
    default:
      return `${t("common.monday")}`;
  }
}

export function makeYearDataForComboBox(
  // maxYear: number = dayjs().add(1,'year').year(),
  maxYear: number = dayjs().year(),
  minYear: number = 2021
) {
  const size = maxYear - minYear + 1;
  if (size < 1) {
    return [
      { body: "2021 ", value: 2021 },
      { body: "2022 ", value: 2022 }
    ];
  } else {
    return Array.from({ length: size }, (_, i) => ({
      body: `${minYear + i}`,
      value: minYear + i
    }));
  }
}

export function localeTimeDeltaString() {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  let timeLocaleTimeDelta = "00+07:00";
  if (timeZone === "Asia/Phnom_Penh") {
    timeLocaleTimeDelta = "00+07:00";
  } else if (timeZone === "Asia/Bangkok") {
    timeLocaleTimeDelta = "00+07:00";
  } else if (timeZone === "Asia/Seoul") {
    timeLocaleTimeDelta = "00+09:00";
  }
  return timeLocaleTimeDelta;
}

export function localeTimeDeltaNumber() {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  // console.log(offset);
  let timeLocaleTimeDelta = 7;
  if (timeZone === "Asia/Phnom_Penh") {
    timeLocaleTimeDelta = 7;
  } else if (timeZone === "Asia/Bangkok") {
    timeLocaleTimeDelta = 7;
  } else if (timeZone === "Asia/Seoul") {
    timeLocaleTimeDelta = 9;
  }
  return timeLocaleTimeDelta;
}

export function makeMonthlyExamIDForComboBox() {
  const currentYear = dayjs().year();
  const maxYear: number = Number(currentYear.toString().slice(-2));

  const currentMonth = dayjs().month() + 1;
  const yearMonth = [];

  for (let month = 1; month < currentMonth + 1; month++) {
    if (month < 10) {
      yearMonth.push({
        body: `${maxYear}-${month}`,
        value: Number(`${currentYear}0${month}`)
      });
    } else {
      yearMonth.push({
        body: `${maxYear}-${month}`,
        value: Number(`${currentYear}${month}`)
      });
    }
  }
  return yearMonth;
}
